import apiRequest from "../apis/api-request";

export const sendFeedback = async ({ name, email, message }) => {
  return await apiRequest({
    method: "POST",
    url: "user/feedback",
    data: {
      name,
      email,
      message,
    },
  });
};
